import { Component, Inject, OnInit } from "@angular/core";
import { DialogTournamentEndResultComponent } from "../dialog-tournament-end-result/dialog-tournament-end-result.component";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TournamentEndResult } from "../../../../shared/models";
import { CurrencyInfo } from "../../../../shared/models/currency-info";

@Component({
  selector: "app-tournament-end-dialog",
  templateUrl: "./tournament-end-dialog.component.html",
  styleUrls: ["./tournament-end-dialog.component.scss"],
})
export class TournamentEndDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogTournamentEndResultComponent>,
    @Inject(MAT_DIALOG_DATA) public data:  {tournamentEndResult: TournamentEndResult, currencyInfo: CurrencyInfo},
  ) {}
}
